import React from 'react';
import { useCompanyContext } from '../../../contexts/Company';
import { useLinesContext } from '../../../contexts/Lines';
import Stepper from '../../../components/Onboarding/BuildingBlocks/OnboardingWrapper';
import PageLayout from '../../../components/Onboarding/Product/Price';

const HEADER = (
  <span>
    What is the <u>average selling price</u> of this product?
  </span>
);

export default function ProductPrice() {
  const { business } = useCompanyContext();
  const { products } = useLinesContext();

  return (
    <Stepper
      title={HEADER}
      hideContent={!(products && business)}
      headerWidth={900}
      contentWidth={900}
    >
      <PageLayout />
    </Stepper>
  );
}
